var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "audio_document",
    "data-name": "audio document",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.223,
    height: 30.223,
    viewBox: "0 0 30.223 30.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2369",
    "data-name": "Trac\\xE9 2369",
    d: "M28.386,7.052h1.007V6.636l-.3-.3ZM22.341,1.007,23.053.3l-.3-.3h-.416Zm4.03,27.2H6.222v2.015H26.371ZM5.215,27.2V3.022H3.2V27.2ZM27.378,7.052V27.2h2.015V7.052ZM6.222,2.015H22.341V0H6.222Zm15.407-.3,6.045,6.045L29.1,6.34,23.053.3ZM6.222,28.208A1.01,1.01,0,0,1,5.215,27.2H3.2a3.023,3.023,0,0,0,3.022,3.022Zm20.148,2.015A3.023,3.023,0,0,0,29.393,27.2H27.378a1.01,1.01,0,0,1-1.007,1.007ZM5.215,3.022A1.01,1.01,0,0,1,6.222,2.015V0A3.023,3.023,0,0,0,3.2,3.022Z",
    transform: "translate(-1.185)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2370",
    "data-name": "Trac\\xE9 2370",
    d: "M0,0H30.223V30.223H0Z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-play-circle",
    "data-name": "Icon ionic-ios-play-circle",
    d: "M-633.167,353.116a6.517,6.517,0,0,0-6.517,6.516,6.517,6.517,0,0,0,6.516,6.517,6.516,6.516,0,0,0,6.517-6.516h0a6.515,6.515,0,0,0-6.514-6.516Zm2.263,6.94-3.52,2.177s-.595.292-.626-.407v-4.11c0-.111-.1-.726.549-.6l3.6,2.2C-630.58,359.543-630.814,360-630.9,360.056Z",
    transform: "translate(648.279 -344.521)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.f65aebcfd4a1f02acbba40e59d71542b.svg";
export { ForwardRef as ReactComponent };